<template>
  <div class="main-wrapper fill-height">
    <v-container
      fluid
      class="fill-height align-stretch"
    >
      <v-row>
        <v-col
          cols="12"
          sm="4"
          lg="3"
          xl="2"
        >
          <SettingsNav class="with-margin d-sticky" />
        </v-col>
        <v-col
          cols="12"
          sm="8"
          lg="9"
          xl="10"
        >
          <router-view />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import SettingsNav from '@/components/Settings/SettingsNav.vue'

export default {
  name: 'SettingsView',

  components: {
    SettingsNav,
  },
}
</script>

<style scoped lang="scss">
.d-sticky {
  position: sticky !important;
  z-index: 1;
  top: 80px;
  &.with-margin {
    top: 72px;
  }
}
</style>
